<template>
    <div class="jump-order nav-bar-fixed">
        <van-nav-bar title="订单详情" left-arrow fixed @click-left="back"/>
        <div class="order-cell-item order-info">
            <h5>卖家信息</h5>
            <!--<van-cell  title="交易快照" value="发生交易争议时，可作为判断依据" is-link />-->
            <van-cell title="店铺名" :value="storeInfo.storeName">
                <!--<span slot="right-icon" class="order-copy" >复制</span>-->
            </van-cell>
            <van-cell title="详细地址" :value="storeInfo.storeAddress"/>
            <van-cell title="QQ" :value="storeInfo.storeQq"/>
            <van-cell title="电话号码" :value="storeInfo.storeTelephone"/>
        </div>

        <div class="order-cell-item">

            <van-row class="jump-order-item" type="flex" v-for="item in orderInfo.goodsList">
                <a :href="'#/gooddetail/'+item.goodsId">
                    <van-col span="8" class="jump-order-item-img">
                        <img :src="item.goodsImg"/>
                    </van-col>
                    <van-col span="16" class="jump-order-item-warp">
                        <h4 class="text-ellipsis" style="white-space: pre-line;"><span v-if="item.giftFlag"
                                                                                       style="color: red">赠 </span>
                            {{item.goodsName}}</h4>
                        <p>单价:￥{{item.price}}</p>
                        <p v-if="item.spec&&item.spec!=''">规格:{{item.spec}}</p>
                        <p>数量:{{item.count}}</p>
                        <p>促销活动名称:{{item.promotionName}}</p>
                    </van-col>
                </a>
            </van-row>
            <!--<van-cell title="运费" value="0.00"/>
            <van-cell title="活动折扣" value="￥1.50"/>-->
            <van-cell class="order-fre" title="实付款" :value="orderPrice | numFilter"/>
            <van-row v-if="orderInfo.orderPoint!=null && orderInfo.orderPoint!=0">
                <van-cell class="order-fre" title="订单赠送积分" :value="orderInfo.orderPoint"/>
            </van-row>
            <van-row v-if="orderInfo.activityPoint!=null && orderInfo.activityPoint!=0">
                <van-cell class="order-fre" title="活动商品赠送积分" :value="orderInfo.activityPoint"/>
            </van-row>

        </div>

        <div class="order-cell-item order-info">
            <h5>订单信息</h5>
            <!--<van-cell  title="交易快照" value="发生交易争议时，可作为判断依据" is-link />-->
            <van-cell title="订单编号" :value="orderInfo.orderId">
                <!--<span slot="right-icon" class="order-copy" >复制</span>-->
            </van-cell>
            <van-cell title="下单时间" :value="orderInfo.createTime"/>
            <van-cell title="发货时间" :value="orderInfo.shipTime"/>
            <van-cell title="订单状态" :value="orderInfo.orderStatus"/>
            <van-cell title="审核状态" :value="orderInfo.checkStauts"/>
            <van-cell title="订单总价" :value="orderInfo.totalPrice"/>
            <van-cell title="应付金额" :value="orderInfo.shouldPayPrice"/>
            <van-cell title="支付方式" :value="orderInfo.payClassName"/>
            <van-row v-if="orderInfo.payClassName=='赊销支付'">
                <van-cell title="赊销时间" :value="orderInfo.payTime"/>
            </van-row>
            <van-row v-else>
                <van-cell title="支付时间" :value="orderInfo.payTime"/>
            </van-row>
            <van-cell title="下单时间" :value="orderInfo.createTime"/>
            <van-cell title="期望到货时间" :value="orderInfo.expectedArrivalTime"/>
            <van-cell title="备注信息" :value="orderInfo.remarks"/>
        </div>

        <div class="order-cell-item order-info">
            <h5>收货地址及发票信息</h5>
            <van-cell title="收货人" :value="orderInfo.receiverName"/>
            <van-cell title="收货地址" :value="orderInfo.receiverAddress"/>
            <van-cell title="电话号码" :value="orderInfo.receiverTel"/>
            <van-cell title="手机号码" :value="orderInfo.receiverMobile"/>

            <van-cell title="牧场名称" :value="orderInfo.ranchName"/>
            <van-cell title="用户名" :value="orderInfo.userName"/>
            <van-cell title="发票类型" :value="orderInfo.invoiceType"/>
            <div v-if="orderInfo.invoiceType=='单位'">
                <van-cell title="发票抬头" :value="orderInfo.invoice"/>
                <van-cell title="纳税人标识码" :value="orderInfo.invoiceIdCode"/>
                <van-cell title="注册地址" :value="orderInfo.regAddress"/>
                <van-cell title="注册电话" :value="orderInfo.regPhone"/>
                <van-cell title="开户银行" :value="orderInfo.openBank"/>
                <van-cell title="银行账户" :value="orderInfo.openAccount"/>
                <van-cell title="邮箱账号" :value="orderInfo.email"/>
                <van-cell title="联系电话" :value="orderInfo.mobile"/>
            </div>
        </div>

        <div class="order-cell-item order-info">
            <h5>操作历史</h5>
            <van-row>
               <span v-for="(item,index) in orderLogList">
                   <div v-if="index==0">{{item.logUserName}}于{{item.createtime}}{{item.logInfo}}</div>
                   <div v-else style="margin-top: 10px">于{{item.createtime}}{{item.logInfo}}</div>
               </span>
            </van-row>
        </div>
        <div class="navbar-foot">
            <van-row>
                <van-col span="3" class="nav-icon">
                    <a href="#/home"><i class="iconfont icon-shouye"></i>
                        <p>首页</p></a>
                </van-col>
                <van-col span="15" class="nav-warp">
                    <van-button size="small" plain type="info" @click="yanchiOrder"
                                v-if="(order.orderStatus == 30 && order.orderGoodsType != 4 && order.delayedReceipt != 1) || (order.orderStatus == 30 && order.orderGoodsType == 4 && order.confirmAgain == 1 && order.delayedReceipt != 1)">
                        延长收货
                    </van-button>
                    <van-button size="small" plain type="info" @click="rebuy()"
                                v-if="status&&userRole.indexOf('BM')!=-1">再次购买
                    </van-button>
                    <van-button size="small" plain type="info" @click="rebuy()"
                                v-if="!status&&userRole.indexOf('BM')==-1">再次购买
                    </van-button>
                    <van-button size="small" plain type="info" @click="shouhuo"
                                v-if="orderInfo.isPartOut=='1'&& orderInfo.orderStatusCode==30">
                        查看出库单
                    </van-button>
                </van-col>
            </van-row>
        </div>
    </div>
</template>
<script>
    import {NavBar, Row, Col, Button, Cell,Collapse,CollapseItem,CellGroup} from "vant";

    export default {
        name: "userOrderDetail",
        components: {
            [NavBar.name]: NavBar,
            [Row.name]: Row,
            [Col.name]: Col,
            [Button.name]: Button,
            [Cell.name]: Cell,
            [Collapse.name]: Collapse,
               [CollapseItem.name]: CollapseItem,
                 [CellGroup.name]: CellGroup,
        },
        data() {
            return {
                userRole: localStorage.getItem("userRole") ? localStorage.getItem("userRole") : "",
                orderId: this.$route.query.id,
                status: this.$route.query.status,
                order: {},
                orderInfo: [],
                orderPrice: 0,
                storeInfo: {},
                orderLogList: []
            };
        }, mounted: function () {
            let that = this
            that.seachOrderByid()
        }, methods: {
            shouhuo() {
                let that = this
                that.$router.push({
                    path: '/user/order/receive',
                    query: {
                        id: that.orderId
                    }
                })
            },
            
            back() {
                history.back();
            }, seachOrderByid() {
                let that = this
                that.$api.get(
                    that.jumuc.order.orderDetail,
                    {"orderId": that.orderId},
                    successRes => {
                        that.order = successRes.data;
                        that.orderLogList = that.order.orderLogList
                        that.orderInfo = that.order.orderInfo
                        that.storeInfo = that.order.storeInfo
                        that.orderPrice = that.order.orderInfo.realPrice == null ? that.order.orderInfo.shouldPayPrice : 0
                    }
                )
            }, yanchiOrder() {
                let that = this
                that.$router.push({
                    path: '/user/order/extend',
                    query: {
                        id: that.orderId,
                        orderId: that.order.orderId
                    }
                })
            }, rebuy() {
                let that = this
                that.$api.post(
                    that.jumuc.order.rebuy,
                    {"orderId": that.orderId},
                    successRes => {
                        if (successRes.success) {
                            that.$router.push({
                                path: '/cart',
                                query: {
                                    id: that.orderId
                                }
                            })
                        }
                    }
                )
            }
        }, filters: {
            numFilter(value) {
                // 截取当前数据到小数点后两位
                let realVal = parseFloat(value).toFixed(2)
                return realVal
            }
        },
//    beforeRouteLeave(to, from, next) {
//         if (to.name == "userorder") {
//             to.meta.keepAlive = true;
//         } else {
//             to.meta.keepAlive = false;
//         }
//         next();
//     }
    };
</script>
<style lang="less">
    @bule-thame: #3c6eeb;
    body {
        background-color: #f7f7f7;
    }

    .jump-order {

        padding-bottom: 60px;

        .order-cell-item {
            background-color: #fff;
            padding: 10px 15px;
            margin-bottom: 15px;
        }
        .order-state {
            color: @bule-thame;
            font-size: 16px;
            padding: 10px 15px;
            background-color: #fff;
        }
        .order-address-cell {
            margin-bottom: 15px;
        }
        .order-address-item {
            border-top: 1px solid #ebedf0;
            padding: 10px 15px;
            background-color: #fff;
            h5 {
                padding-top: 5px;
                font-size: 16px;
                color: @bule-thame;
            }
            p {
                color: #666;
                font-size: 14px;
            }
            i {
                height: 45px;
                width: 45px;
                line-height: 45px;
                display: inline-block;
                color: #fff;
                background-color: @bule-thame;
                font-size: 20px;
                border-radius: 100%;
            }
        }

        &-item {
            background-color: #fff;
            margin-bottom: 15px;
            align-items: center;
            border-radius: 20px;
            padding: 15px;
            position: relative;
            .van-checkbox {
                height: 100%;
                line-height: 100%;
            }
            &-img {
                img {
                    width: 100%;
                }
            }

            h4 {
                font-size: 16px;
                padding: 10px 0;
            }
            &-warp {
                align-self: flex-start;
            }
            p {
                font-size: 16px;
                &.item-time {
                    font-size: 16px;
                    span {
                        float: right;
                        color: @bule-thame;
                    }
                    span.order-cancel {
                        color: green;
                    }
                }
                &.item-price {
                    font-size: 16px;
                    text-align: right;
                }
            }
            button {
                float: right;
                margin-top: 10px;
                border-radius: 25%;
            }

        }

        .order-info {
            h5 {
                font-size: 16px;
                color: @bule-thame;
                padding: 10px 0 20px;
            }
            .van-cell__title {
                flex: none;
                min-width: 90px;
            }
            .van-cell__value {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                text-align: left
            }
            .order-copy {
                color: @bule-thame;
            }
        }

        .order-fre {
            .van-cell__value {
                color: red;
            }
        }

        .van-cell:not(:last-child)::after {
            border-width: 0;
        }
    }

    .navbar-foot {
        background-color: #fff;
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 55px;
        padding: 5px 0 0;
        border-top: 1px solid #f7f7f7;
        .nav-icon {
            text-align: center;
            font-size: 10px;
            i {
                font-size: 20px;
            }
        }
        .nav-warp {
            padding: 10px 0;
            text-align: right;
            button {
                margin-right: 5px;
                color: #999;
                border-color: #999;
                border-radius: 15px;
                font-size: 12px;
                padding: 0 10px;
                &.van-button--info {
                    color: @bule-thame;
                    border-color: @bule-thame;
                }
            }
        }

    }

    span {
        white-space: initial;
    }
</style>


